  <div data-cy="content-area-main-container">
  <div class="app-content-header" data-cy="content-area-header-container">
    <div class="app-content-header-label" data-cy="content-area-header-label-container">
      <span style="position: relative; top: 6px;" attr.data-cy="content-area-label-{{label}}">{{label}}</span>
    </div>
    <ng-container *ngIf="showAddButton === true">
      <button matTooltip="Add" mat-icon-button style="cursor: pointer; flex-basis: 40px; color: white; position: relative; bottom: 0;" (click)="onClick($event)" data-cy="content-area-add-button"><mat-icon data-cy="content-area-add-icon">add_box</mat-icon></button>
    </ng-container>
  </div>
  <div class="app-content-main" data-cy="content-area-ng-content-container">
    <ng-content></ng-content>
  </div>
</div>
